import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { NgbCollapseModule, NgbDatepickerModule, NgbTimepickerModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { CoacheeDpaComponent } from './coachee-dpa/coachee-dpa.component';
import { CoacheeAiAgreementComponent } from './coachee-ai-agreement/coachee-ai-agreement.component';

@NgModule({
  declarations: [
    CoacheeAiAgreementComponent,
    CoacheeDpaComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgbCollapseModule,
    NgbDatepickerModule,
    NgbTimepickerModule,
    NgbDropdownModule,
    RouterModule
  ],
  exports: []
})
export class UIModule { }
